import {
  AlertTriangle,
  Bell,
  CheckCircle2,
  Eye,
  FilePen,
  Heart,
  Info,
  Settings2,
  ShieldAlert,
  TrendingUp,
  Trophy,
  UserPlus,
  XCircle,
} from "lucide-react";

/** Khớp NOTIFICATION_TYPES ở backend (services/adminNotificationService.js). */
export const TYPE_META = {
  location_milestone: { label: "Mốc lượt xem", icon: Eye, group: "traffic", color: "bg-sky-600", text: "text-sky-600" },
  favorite_milestone: { label: "Được yêu thích", icon: Heart, group: "traffic", color: "bg-rose-500", text: "text-rose-500" },
  traffic_spike: { label: "Truy cập tăng mạnh", icon: TrendingUp, group: "traffic", color: "bg-emerald-600", text: "text-emerald-600" },
  traffic_record: { label: "Kỷ lục truy cập", icon: Trophy, group: "traffic", color: "bg-amber-500", text: "text-amber-500" },
  user_signup: { label: "Người dùng mới", icon: UserPlus, group: "account", color: "bg-violet-600", text: "text-violet-600" },
  security: { label: "Bảo mật", icon: ShieldAlert, group: "account", color: "bg-red-600", text: "text-red-600" },
  content_change: { label: "Nội dung", icon: FilePen, group: "system", color: "bg-teal-600", text: "text-teal-600" },
  settings_change: { label: "Cài đặt website", icon: Settings2, group: "system", color: "bg-slate-700", text: "text-slate-700" },
  system: { label: "Hệ thống", icon: Bell, group: "system", color: "bg-blue-600", text: "text-blue-600" },
};

export const GROUP_META = [
  { id: "traffic", label: "Lượt xem & tương tác" },
  { id: "account", label: "Tài khoản & bảo mật" },
  { id: "system", label: "Hệ thống" },
];

export const TYPE_ORDER = Object.keys(TYPE_META);

const SEVERITY_ICON = { info: Info, success: CheckCircle2, warning: AlertTriangle, danger: XCircle };

export const SEVERITY_TONE = {
  info: "bg-sky-50 text-sky-700",
  success: "bg-emerald-50 text-emerald-700",
  warning: "bg-amber-50 text-amber-700",
  danger: "bg-rose-50 text-rose-700",
};

/** Màu nền đặc cho icon theo mức độ (dùng khi loại thông báo không có màu riêng). */
const SEVERITY_SOLID = { info: "bg-sky-600", success: "bg-emerald-600", warning: "bg-amber-500", danger: "bg-rose-600" };

/** Lớp nền đặc + chữ trắng cho icon thông báo: cảnh báo/nguy hiểm ưu tiên màu mức độ, còn lại theo loại. */
export function iconToneFor(n) {
  if (n.severity === "danger" || n.severity === "warning") return SEVERITY_SOLID[n.severity];
  return TYPE_META[n.type]?.color || SEVERITY_SOLID[n.severity] || SEVERITY_SOLID.info;
}

export function iconFor(n) {
  return TYPE_META[n.type]?.icon || SEVERITY_ICON[n.severity] || Bell;
}

export function timeAgo(iso) {
  const t = new Date(iso).getTime();
  if (!Number.isFinite(t)) return "";
  const s = Math.max(0, Math.round((Date.now() - t) / 1000));
  if (s < 45) return "Vừa xong";
  const m = Math.round(s / 60);
  if (m < 60) return `${m} phút trước`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} giờ trước`;
  const d = Math.round(h / 24);
  if (d < 7) return `${d} ngày trước`;
  return new Date(iso).toLocaleDateString("vi-VN", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function fullTime(iso) {
  return new Date(iso).toLocaleString("vi-VN", { dateStyle: "full", timeStyle: "short" });
}

/** Nhóm theo ngày: Hôm nay / Hôm qua / Tuần này / Trước đó. */
export function dayBucket(iso) {
  const d = new Date(iso);
  const start = (x) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const diff = Math.round((start(new Date()) - start(d)) / 86400000);
  if (diff <= 0) return "Hôm nay";
  if (diff === 1) return "Hôm qua";
  if (diff < 7) return "Tuần này";
  return "Trước đó";
}

export const BUCKET_ORDER = ["Hôm nay", "Hôm qua", "Tuần này", "Trước đó"];
